/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrizeDistributionTournamentSummary
 */
export interface PrizeDistributionTournamentSummary {
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionTournamentSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionTournamentSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PrizeDistributionTournamentSummary
     */
    status: string;
}

/**
 * Check if a given object implements the PrizeDistributionTournamentSummary interface.
 */
export function instanceOfPrizeDistributionTournamentSummary(value: object): value is PrizeDistributionTournamentSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PrizeDistributionTournamentSummaryFromJSON(json: any): PrizeDistributionTournamentSummary {
    return PrizeDistributionTournamentSummaryFromJSONTyped(json, false);
}

export function PrizeDistributionTournamentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeDistributionTournamentSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'],
    };
}

export function PrizeDistributionTournamentSummaryToJSON(json: any): PrizeDistributionTournamentSummary {
    return PrizeDistributionTournamentSummaryToJSONTyped(json, false);
}

export function PrizeDistributionTournamentSummaryToJSONTyped(value?: PrizeDistributionTournamentSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': value['status'],
    };
}

